module.exports = __webpack_public_path__ + "img/road.f8b3c234.png";